import { createContext } from "react";
import noop from "lodash/noop";
export var NavigationContext = createContext({
  activeRoute: "",
  setActiveRoute: noop,
  isCollapsed: !1,
  expand: noop,
  collapse: noop
});